/** @format */

// project
import { http } from "@/http";
import { Widget } from "@/psychlab/types/widget";

export const getWidgets = async (studyId: string): Promise<Widget[]> => {
	const { data } = await http.get(`studies/${studyId}/analytics/widgets`);
	return data;
};